import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('hubspot-prosemirror', {
  library: 'hubspot-prosemirror'
});